import { Component, OnDestroy, OnInit } from '@angular/core';
// import { bulkUploadConfig } from '../consts/bulk-upload-config';
// import { BulkUploadService } from '../services/bulk-upload.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationModalComponent } from '../../shared/modal/confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'app-lca-details',
  templateUrl: './lca-details.component.html',
  styleUrls: ['./lca-details.component.scss']
})
export class LcaDetailsComponent  {

  constructor() { }

  ngOnInit(): void {
  }
}
